import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

const FULL_SCREEN_PAYWALL_ROOT_CLASS = 'full-screen-paywall-open';

const FullScreenPaywallShell = ({
  className,
  onClose,
  children,
}: {
  className?: string;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  const [portalTarget, setPortalTarget] = useState<HTMLElement | null>(null);
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useLayoutEffect(() => {
    const root = document.documentElement;

    root.classList.add(FULL_SCREEN_PAYWALL_ROOT_CLASS);
    window.scrollTo(0, 0);
    setPortalTarget(document.body);

    return () => {
      root.classList.remove(FULL_SCREEN_PAYWALL_ROOT_CLASS);
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onCloseRef.current();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  if (!portalTarget) {
    return null;
  }

  return createPortal(
    <div
      role="dialog"
      aria-modal="true"
      className={clsx(
        'absolute left-0 top-0 z-[1001] flex min-h-[100dvh] w-full flex-col',
        className
      )}
    >
      {children}
    </div>,
    portalTarget
  );
};

export default FullScreenPaywallShell;
